import { useMemo } from 'react';
import { useFetchOutOfOfficeStatusesQuery } from '../../__generated__/chirp/com/hubspot/cv/assignments/rpc/OutOfOfficeHoursRpc.hooks';
import type { OutOfOfficeStatus } from '../../__generated__/chirp/com/hubspot/cv/assignments/rpc/OutOfOfficeHoursRpc';
import { captureException } from '../utils/sentryUtils';

export type OutOfOfficeStatuses = Record<string, OutOfOfficeStatus>;

const EMPTY_STATUSES: OutOfOfficeStatuses = {};

export const useOutOfOfficeStatuses = (
  userIds: number[]
): OutOfOfficeStatuses => {
  // The query is cached per exact variables, so equal id sets must be ordered
  // identically for the sidebar and builders to share one response.
  const sortedUserIds = useMemo(
    () => Array.from(new Set(userIds)).sort((a, b) => a - b),
    [userIds]
  );

  const { data } = useFetchOutOfOfficeStatusesQuery({
    variables: { userIds: sortedUserIds },
    skip: sortedUserIds.length === 0,
    onError: (err: Error) => {
      captureException(err, {
        extra: { fingerprint: 'useOutOfOfficeStatuses-fetch' },
      });
    },
  });

  return data?.statuses ?? EMPTY_STATUSES;
};
